"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formUnmount = formUnmount;
var _utils = require("../../utils");
function formUnmount() {
  return function (getState, dispatch) {
    const {
      eventHandler,
      formElement
    } = getState();
    (0, _utils.addOrRemoveFormEvents)(formElement, 'remove', eventHandler);
    dispatch({
      payload: {
        newState: (0, _utils.initializeReducerState)()
      },
      type: 'formUnmount'
    }, true);
  };
}